export default "__VITE_ASSET__D7WZb9OY__"